/**
 * Custom Mirror Builder - Gallery Interaction
 */
document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('.mirror-builder__main-img');
  const thumbnails = document.querySelectorAll('.mirror-builder__thumb');
  const thumbnailsContainer = document.querySelector('.mirror-builder__thumbnails');

  if (!mainImage || !thumbnails.length) return;

  // Ensure first thumbnail is active on load (if no active thumbnail exists)
  const hasActive = Array.from(thumbnails).some(t => t.classList.contains('mirror-builder__thumb--active'));
  if (!hasActive && thumbnails[0]) {
    thumbnails[0].classList.add('mirror-builder__thumb--active');
  }

  // Handle thumbnail click
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const thumbnailImg = thumbnail.querySelector('.mirror-builder__thumb-img');
      
      if (!thumbnailImg) return;

      // Update main image
      const newSrc = thumbnailImg.src.replace(/width=\d+/, 'width=800');
      const newSrcset = `${thumbnailImg.src.replace(/width=\d+/, 'width=400')} 400w, ${thumbnailImg.src.replace(/width=\d+/, 'width=800')} 800w, ${thumbnailImg.src.replace(/width=\d+/, 'width=1200')} 1200w`;
      
      mainImage.src = newSrc;
      mainImage.srcset = newSrcset;
      mainImage.alt = thumbnailImg.alt;

      // Update active state
      thumbnails.forEach((t) => t.classList.remove('mirror-builder__thumb--active'));
      thumbnail.classList.add('mirror-builder__thumb--active');

      // Scroll thumbnail into view (mobile only)
      if (window.innerWidth < 1000 && thumbnailsContainer) {
        const thumbnailLeft = thumbnail.offsetLeft;
        const thumbnailWidth = thumbnail.offsetWidth;
        const containerWidth = thumbnailsContainer.offsetWidth;
        const scrollPosition = thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2);
        
        thumbnailsContainer.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // Add keyboard navigation
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.setAttribute('tabindex', '0');
    thumbnail.setAttribute('role', 'button');
    thumbnail.setAttribute('aria-label', `View image ${index + 1}`);

    thumbnail.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        thumbnail.click();
      }
    });
  });

  // Add swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  if (thumbnailsContainer && window.innerWidth < 1000) {
    thumbnailsContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    thumbnailsContainer.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
  }

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) < swipeThreshold) return;

    // Find current active thumbnail
    const activeIndex = Array.from(thumbnails).findIndex((t) =>
      t.classList.contains('mirror-builder__thumb--active')
    );

    let nextIndex;
    if (diff > 0 && activeIndex < thumbnails.length - 1) {
      // Swipe left - next image
      nextIndex = activeIndex + 1;
    } else if (diff < 0 && activeIndex > 0) {
      // Swipe right - previous image
      nextIndex = activeIndex - 1;
    }

    if (nextIndex !== undefined && thumbnails[nextIndex]) {
      thumbnails[nextIndex].click();
    }
  }
});

/**
 * Mobile Sticky CTA Behavior
 * Shows sticky CTA as soon as user starts scrolling (scrollY > 0)
 * Hides when the inline CTA (.mirror-builder__cta) is visible in the viewport
 */
document.addEventListener('DOMContentLoaded', () => {
  const inlineCta = document.querySelector('.mirror-builder__cta');
  const stickyWrapper = document.querySelector('[data-sticky-cta]');

  if (!stickyWrapper) return;

  // Only apply on mobile/tablet (below 1000px)
  if (window.innerWidth >= 1000) return;

  let inlineCtaVisible = false;
  let ticking = false;

  // Track inline CTA visibility via IntersectionObserver
  if (inlineCta) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        inlineCtaVisible = entry.isIntersecting;
        updateStickyVisibility();
      });
    }, { threshold: 0, rootMargin: '0px' });

    observer.observe(inlineCta);
  }

  function updateStickyVisibility() {
    // Show only if user has scrolled AND inline CTA is not visible
    if (window.scrollY > 0 && !inlineCtaVisible) {
      stickyWrapper.classList.add('is-visible');
    } else {
      stickyWrapper.classList.remove('is-visible');
    }
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateStickyVisibility);
      ticking = true;
    }
  }, { passive: true });

  // Check on load
  updateStickyVisibility();

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1000) {
      stickyWrapper.classList.remove('is-visible');
    } else {
      updateStickyVisibility();
    }
  });
});


// ── ZIP delivery-area checker ────────────────────────────────
// 3-digit ZIP prefixes within ~100 miles of each delivery hub.
// Prefix centroids are coarse, so borderline calls lean inclusive:
// the "not covered" message invites contact anyway (we make route
// exceptions), and the exact delivery fee is computed at checkout.
// The builder CTA is never gated on the result.
document.addEventListener('DOMContentLoaded', () => {
  const HUB_PREFIXES = [
    // Minneapolis
    '540','547','550','551','553','554','555','559','560','562','563','564',
    // Chicago (incl. NW Indiana + SE Wisconsin)
    '463','464','466','530','531','532','600','601','602','603','604','605','606','607','608','609','610','611',
    // Dallas–Fort Worth
    '750','751','752','753','754','757','760','761','762','764','765','766','767',
    // Denver (incl. Springs + Cheyenne)
    '800','801','802','803','804','805','806','807','808','809','820',
    // Des Moines
    '500','501','502','503','505','508','525',
    // Omaha (incl. SW Iowa + Lincoln)
    '511','515','516','680','681','683','685','686',
    // Kansas City (incl. Topeka + St. Joseph)
    '640','641','644','645','646','647','653','660','661','662','664','665','666',
    // Phoenix
    '850','851','852','853','855','863'
  ];

  document.querySelectorAll('[data-zip-toggle]').forEach((toggle) => {
    const scope = toggle.closest('.mirror-builder__cta-content');
    const panel = scope && scope.querySelector('[data-zip-panel]');
    if (!panel) return;
    const input = panel.querySelector('[data-zip-input]');
    const submit = panel.querySelector('[data-zip-submit]');
    const result = panel.querySelector('[data-zip-result]');

    toggle.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
      if (!panel.hidden && input) input.focus();
    });

    const check = () => {
      const zip = (input.value || '').trim();
      if (!/^\d{5}$/.test(zip)) {
        result.hidden = false;
        result.className = 'mirror-builder__zip-result mirror-builder__zip-result--invalid';
        result.textContent = 'Please enter a 5-digit ZIP code.';
        return;
      }
      const covered = HUB_PREFIXES.includes(zip.slice(0, 3));
      try {
        if (typeof window.mdCroCheckZip === 'function') window.mdCroCheckZip(zip, covered);
      } catch (e) { /* analytics must never break the page */ }
      result.hidden = false;
      if (covered) {
        result.className = 'mirror-builder__zip-result mirror-builder__zip-result--yes';
        result.textContent = '✓ Good news — ' + zip + ' is in our delivery area. Build your set below.';
      } else {
        result.className = 'mirror-builder__zip-result mirror-builder__zip-result--no';
        result.innerHTML = zip + ' isn’t on our standard routes yet — but we make exceptions when we can. <a href="/pages/contact" class="mirror-builder__zip-result-link">Reach out</a> and we’ll see what’s possible.';
      }
    };

    if (submit) submit.addEventListener('click', check);
    if (input) input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
    });
  });
});

// ── Sticky buy-box: bottom-anchor when taller than viewport ──
// Replaces the old max-height + overflow-y:auto nested scroller, which
// trapped mouse-wheel scrolling whenever the cursor sat over the column.
// If the column fits the viewport it pins at top:16px as before; if it
// is taller, top goes negative so the page scroll carries the column up
// until its bottom (the CTA) is in view, then it pins there.
document.addEventListener('DOMContentLoaded', () => {
  const info = document.querySelector('.mirror-builder__info');
  if (!info) return;

  const setStickyTop = () => {
    // Mobile: display:contents -> offsetHeight 0; sticky CSS is
    // desktop-only, so just leave the var alone there.
    const h = info.offsetHeight;
    if (!h) return;
    const vh = window.innerHeight;
    const top = h + 32 <= vh ? 16 : vh - h - 16;
    info.style.setProperty('--md-info-sticky-top', top + 'px');
  };

  // Column height changes as the ZIP panel / accordions open and close.
  if (window.ResizeObserver) new ResizeObserver(setStickyTop).observe(info);
  window.addEventListener('resize', setStickyTop);
  setStickyTop();
});
